// extracted by mini-css-extract-plugin
export default {"wrapper":"miss-match_wrapper__efiHx","fade-in-out":"miss-match_fade-in-out__73yy7","aside":"miss-match_aside__rXbkX","icon":"miss-match_icon__ennBK"};